import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <div className="w-24 h-24 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-6">
            <i className="ri-error-warning-line text-4xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">404</h1>
          <p className="text-base text-foreground-500 mb-8">抱歉，您访问的页面不存在</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i> 返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}